import React from "react";
import { Typography, CardContent, Stack, Box, Avatar } from "@mui/material";
// import CreateButton from '../styled-components/buttons'
import { useNavigate } from "react-router-dom";
import { StyledCard } from "../../assets/styled-components/StyledCard";
import QueueIcon from "@mui/icons-material/Queue";
import { updateOutsourceDetails, updateWorkOrderStatus } from "../../redux/actions/workOrderActionTypes";
import { useDispatch } from "react-redux";



function CreateWorkOrder() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const handleClick = () => {
    dispatch({ type: 'CLEAR_BASIC_DETAILS_WORK_ORDER_SUMMARY', payload: {} });
    dispatch({ type: 'CLEAR_DECRYPTDATA_HYPERLINK', payload: {} });
    dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: "", percentage: 0 }));
    dispatch(updateOutsourceDetails("SET_VENDORFIELD", false));
    dispatch({ type: "SERVICE&CATEGORY_TYPE", payload: { category: 'Unscheduled' } });
    navigate("/workorder/register",{ state: { title:"Create Unscheduled Work Order",editmode:false,isHyperlink:false,isCreateMode:true }  });
    // navigate("/workorder/register",{ state: { title:"Create Unscheduled Work Order",editmode:false,isHyperlink:false,isCreateMode:true,year: "2025",
    //   month: { value: "February", label: "February", id: "02" } } });
  };

  return (
    <>
       <StyledCard sx={{ cursor: "pointer", bgcolor: "primary.light"}}>
        <CardContent onClick={handleClick}>
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            mb={1}
          >
            <Box>
              <Typography mb={1} variant="subtitle1" color={"common.white"}>
                Create New Work Order (WO)
              </Typography>
              <Typography m={0} variant="h1" color={"common.white"}>
                
              </Typography>
            </Box>
            <Box  p={1} >
              <QueueIcon sx={{ fontSize: 30, color: "common.white"}}/>
            </Box>
          </Stack>
        </CardContent>
      </StyledCard>
    </>
  );
}

export default CreateWorkOrder;
